module.exports = __webpack_public_path__ + "img/7b97dbd9c0fb893652fd3438b519e202.svg";